import { useContext } from 'react';
import { SampleDataContext } from './sampleDataContext.js';

function useSampleData(id) {
    const data = useContext(SampleDataContext);
    if (!id || !data[id]) {
        return {
            isLoading: false,
            data: []
        };
    }
    return data[id];
}

export { useSampleData };
//# sourceMappingURL=UseSampleData.js.map
